import { I18nComponente } from "@/types/gerais"

export const OSelecionarTiposDeAtividadei18n: I18nComponente = {
  "pt-BR": {
    nome: "nome",
    codigo: "código",
    pesquisarPorNome: "pesquisar por nome",
    pesquisarPorCodigo: "pesquisar por código",
    limpar: "Limpar",
    aplicar: "Aplicar",
    adicionar: "adicionar",
    atividades: "atividades",
    cancelar: "cancelar"
  },
  "es-CO": {
    nome: "nombre",
    codigo: "código",
    pesquisarPorNome: "buscar por nombre",
    pesquisarPorCodigo: "buscar por código",
    limpar: "Borrar",
    aplicar: "Aplicar",
    adicionar: "agregar",
    atividades: "actividades",
    cancelar: "cancelar"
  }
}
